module.exports = __webpack_public_path__ + "src/img/menu-green.18bb21f8.svg";